import { useState } from 'react'
import { Form, Input, App, Modal } from 'antd'
import { useQiyeAddMutation } from '../../store/dianshangtaizhangApi';
import { useFyqiyeAddMutation } from '../../store/feiyongbaoxiaoApi';
import { PlusSquareOutlined } from '@ant-design/icons';

function FirmAdd(props) {
    const { message } = App.useApp()
    const [open, setOpen] = useState(false)
    const [form] = Form.useForm();
    
    // 定义API映射表
    const apiMap = {
        dianshangtaizhang: useQiyeAddMutation,
        feiyongbaoxiao: useFyqiyeAddMutation
        // 未来可以轻松添加新的softId
    };

    // 根据softId选择对应的mutation hook
    const useAddMutation = apiMap[props.softId] || useQiyeAddMutation;
    const [submit] = useAddMutation();

    const [info, setInfo] = useState({
        "qy_name": '',
        "qy_state": '正常',
        "qy_uid": props.eu_id,
        "qy_uname": props.eu_name,
        'qy_gly_name':'刘益轩',
        'qy_gly_phone':'18794423570',
        'qy_account_remain':'1'
    })

    const handleSubmit = async () => {
        try {
            const result = await submit(info).unwrap();
            
            if (result.Status === 'success') {
                message.success('新增企业成功！');
                form.resetFields();
                setOpen(false);
            } else {
                message.error('新增企业失败！' + result.Message);
            }
        } catch (error) {
            message.error('请求失败：' + (error.data?.Message || error.message));
        }
    }

    return (
        <>
            <a onClick={() => { setOpen(true) }}><PlusSquareOutlined /> 新增企业</a>
            <Modal
                open={open}
                width={800}
                onCancel={() => { setOpen(false) }}
                onOk={handleSubmit}
                title='新增企业'
            >
                <Form
                    form={form}
                    layout="horizontal"
                    name="form_client"
                    initialValues={{ modifier: 'public' }}
                    labelCol={{ span: 3 }}
                >
                    <Form.Item name="name" wrapperCol={{ span: 10 }} required label='企业名称'>
                        <Input onChange={(e) => {
                            setInfo(prevState => ({ ...prevState, qy_name: e.target.value }))
                        }} />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default FirmAdd